export default [
    {
        name: 'MyFiles',
        path: 'MyFiles',
        redirect: { name: 'allFiles' }, // 重定向到指定名称的路由,
        component: () => import('@/pages/BigData/Briefcase/MyFiles'),
        meta: { title: '我的文件' },
        props(route) {
            return {
                id: route.query.id,
            }
        },
        children: [
            {
                name: 'allFiles',
                path: 'allFiles',
                component: () => import('@/pages/BigData/Briefcase/MyFiles/allFiles'),
                meta: { title: '全部文件' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            }
        ]
    },
    {
        name: 'PatentWord',
        path: 'PatentWord',
        redirect: { name: 'AllWord' }, // 重定向到指定名称的路由,
        component: () => import('@/pages/BigData/Briefcase/PatentWord'),
        meta: { title: '专利表格下载' },
        props(route) {
            return {
                id: route.query.id,
            }
        },
        children: [
            {
                name: 'AllWord',
                path: 'AllWord',
                component: () => import('@/pages/BigData/Briefcase/PatentWord/AllWord'),
                meta: { title: '全部' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'baomishencha',
                path: 'baomishencha',
                component: () => import('@/pages/BigData/Briefcase/PatentWord/baomishencha'),
                meta: { title: '保密审查类' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'FushenWuxiao',
                path: 'FushenWuxiao',
                component: () => import('@/pages/BigData/Briefcase/PatentWord/FushenWuxiao'),
                meta: { title: '复审及无效类' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'generic',
                path: 'generic',
                component: () => import('@/pages/BigData/Briefcase/PatentWord/generic'),
                meta: { title: '通用类' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'PCT',
                path: 'PCT',
                component: () => import('@/pages/BigData/Briefcase/PatentWord/PCT'),
                meta: { title: 'PCT进入中国国家阶段类' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'PriorityReview',
                path: 'PriorityReview',
                component: () => import('@/pages/BigData/Briefcase/PatentWord/PriorityReview'),
                meta: { title: '优先审查类' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'serviceClass',
                path: 'serviceClass',
                component: () => import('@/pages/BigData/Briefcase/PatentWord/serviceClass'),
                meta: { title: '服务类' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'waiguanguoji',
                path: 'waiguanguoji',
                component: () => import('@/pages/BigData/Briefcase/PatentWord/waiguanguoji'),
                meta: { title: '外观设计国际申请类' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'xingzhengfuyi',
                path: 'xingzhengfuyi',
                component: () => import('@/pages/BigData/Briefcase/PatentWord/xingzhengfuyi'),
                meta: { title: '行政复议类' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
        ]
    },
    {
        name: 'brandWord',
        path: 'brandWord',
        redirect: { name: 'barndAll' }, // 重定向到指定名称的路由,
        component: () => import('@/pages/BigData/Briefcase/brandWord'),
        meta: { title: '商标表格下载' },
        props(route) {
            return {
                id: route.query.id,
            }
        },
        children: [
            {
                name: 'barndAll',
                path: 'barndAll',
                component: () => import('@/pages/BigData/Briefcase/brandWord/barndAll'),
                meta: { title: '全部' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'barndshenqing',
                path: 'barndshenqing',
                component: () => import('@/pages/BigData/Briefcase/brandWord/barndshenqing'),
                meta: { title: '申请业务类' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'barndhouxu',
                path: 'barndhouxu',
                component: () => import('@/pages/BigData/Briefcase/brandWord/barndhouxu'),
                meta: { title: '后续业务类' },
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'barndpingshen',
                path: 'barndpingshen',
                component: () => import('@/pages/BigData/Briefcase/brandWord/barndpingshen'),
                meta: { title: '后续业务类' },
                props(route) {
                    return {
                        id: route.query.id
                    }
                },
            },
        ]
    },
    {
        name: 'CopyrightWord',
        path: 'CopyrightWord',
        redirect: { name: 'CopyrightAll' }, // 重定向到指定名称的路由,
        component: () => import('@/pages/BigData/Briefcase/CopyrightWord'),
        meta: { title: '版权表格下载' },
        props(route) {
            return {
                id: route.query.id
            }
        },
        children: [
            {
                name: 'CopyrightAll',
                path: 'CopyrightAll',
                component: () => import('@/pages/BigData/Briefcase/CopyrightWord/CopyrightAll'),
                meta: { title: '全部' },
                props(route) {
                    return {
                        id: route.query.id
                    }
                },
            },
            {
                name: 'Copyrightshengqing',
                path: 'Copyrightshengqing',
                component: () => import('@/pages/BigData/Briefcase/CopyrightWord/Copyrightshengqing'),
                meta: { title: '申请业务类' },
                props(route) {
                    return {
                        id: route.query.id
                    }
                },
            },
        ]
    },
]
